import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { EmailTemplatesAutoReplyHttpClient } from '../auto-reply-http-client';
import { EmailTemplatesAutoReplyCollectionActions } from './auto-reply-collection.store';

@Injectable({ providedIn: 'root' })
export class EmailTemplatesAutoReplyCollectionEffects {
  public effects = createEffectFactory(EmailTemplatesAutoReplyCollectionActions, this.actions$);

  public fetchCollection$ = this.effects(
    EmailTemplatesAutoReplyCollectionActions.fetchCollection,
    () => this.emailTemplatesAutoReplyHttpClient.loadCollection().pipe(map(data => ({ data }))),
  );

  public updatePositions$ = this.effects(
    EmailTemplatesAutoReplyCollectionActions.updatePositions,
    ({ payload }) =>
      this.emailTemplatesAutoReplyHttpClient.updatePositions(payload).pipe(
        map(data =>
          EmailTemplatesAutoReplyCollectionActions.updatePositionsSuccess({ payload: { data } }),
        ),
        catchError(error =>
          of(EmailTemplatesAutoReplyCollectionActions.updatePositionsFailed({ payload: error })),
        ),
      ),
  );

  public loadOfferTemplates$ = this.effects(
    EmailTemplatesAutoReplyCollectionActions.fetchOfferCollection,
    ({ payload }) =>
      this.emailTemplatesAutoReplyHttpClient.loadOfferTemplates(payload).pipe(
        map(data =>
          EmailTemplatesAutoReplyCollectionActions.fetchOfferCollectionSuccess({
            payload: { data },
          }),
        ),
        catchError(error =>
          of(
            EmailTemplatesAutoReplyCollectionActions.fetchOfferCollectionFailed({ payload: error }),
          ),
        ),
      ),
  );

  constructor(
    private emailTemplatesAutoReplyHttpClient: EmailTemplatesAutoReplyHttpClient,
    private actions$: Actions,
  ) {}
}
